import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withFirebase } from '../../components/Firebase';
import styled from 'styled-components'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'



const SignUpPage = () => (
    <div>
        <h1>Sign Up</h1>
        <SignUpForm />
    </div>
);

const Styles = styled.div`
  .button {
    background-color: #000;
    margin: 3px
    border-color: #000
  }

  .card {

  }

  .InputRow {
    display: flex;
    align-items: center;
  }

  .Login {
    padding-bottom: 10px;
  }
`;

const INITIAL_STATE = {
    email: '',
    passwordOne: '',
    passwordTwo: '',
    password: '',
    error: null,
};


class SignUpFormBase extends Component {
    constructor(props) {
        super(props);



        this.state = { ...INITIAL_STATE, showLogin: false, showSignUp: false };

    }


    onSubmit = event => {
        const { email, passwordOne } = this.state;

        this.props.firebase
            .doCreateUserWithEmailAndPassword(email, passwordOne)
            .then(authUser => {
                this.setState({ ...INITIAL_STATE });
                console.log('!!!!!!oh we got a new user!!!!')
            })
            .catch(error => {
                this.setState({ error });
                console.error(error.message)
            });
        event.preventDefault();
    }

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    loginFieldManager = () => {
        this.setState({ showLogin: true })
    }

    signupFieldManager = () => {
        this.setState({ showSignUp: !this.state.showSignUp })
        if (this.state.showSignUp === true) this.setState({ showLogin: false })
    }


    render() {

        const {

            email,
            passwordOne,
            passwordTwo,
            password,
            error,
        } = this.state;

        const isInvalid =
            passwordOne !== passwordTwo ||
            passwordOne === '' ||
            email === ''


        return (
            <Styles>
                <h2>{this.state.email}</h2>
                <Form>
                    <Form.Row className="InputRow">
                        <Form.Group as={Col} controlId="formGridEmail">
                            <Form.Control onChange={this.onChange} type="email" placeholder="Enter email" />
                        </Form.Group>

                        <Form.Group as={Col} className="Login">
                            <Button onPress={this.loginFieldManager} variant="success">Already have an account?</Button>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row className="InputRow">
                        <Form.Group as={Col} controlId="formGridEmail">

                            <Button variant="dark" type="submit" onPress={this.signupFieldManager}>
                                Create Account
                    </Button>
                        </Form.Group>

                        <Form.Group as={Col} className="Login">
                            <Button variant="outline-dark" type="submit">
                                Guest Checkout
                    </Button>
                        </Form.Group>
                    </Form.Row>

                    {
                        this.state.showSignUp ?
                            (
                                <Form.Row>
                                    <Form.Group as={Col}>
                                        <Form.Control placeholder="Choose password" onChange={this.onChange} />
                                    </Form.Group>
                                    <Form.Group as={Col}>
                                        <Form.Control placeholder="Enter password again" onChange={this.onChange} />
                                    </Form.Group>
                                    <Button type="submit" disabled={isInvalid} onPress={this.onSubmit}>Submit</Button>
                                </Form.Row>
                            )
                            : (null)
                    }
                    {
                        this.state.showLogin ?
                            (<Form.Group>
                                <Form.Control value={password} placeholder="Password" onChange={this.onChange} />
                            </Form.Group>)
                            : (null)
                    }


                </Form>
            </Styles>
        );
    }
}


const SignUpLink = () => (
    <p>
        Don't have an account? <Link to={{
            pathname: "/email",
            data: {
            }

        }}>Sign Up</Link>
    </p>
);

const SignUpForm = withFirebase(SignUpFormBase);

export default SignUpPage;
export { SignUpForm, SignUpLink };